// $(window).scroll(function(){
//   if($(window).scrollTop() >= 100){
//     $("div#shopify-section-product-sticky").addClass("product-sticky-fix");
//   }else{
//     $("div#shopify-section-product-sticky").removeClass("product-sticky-fix");
//   }
// });
// ===================== Product sticky =====================
$('.product-sticky-right button').on('click', function(){
  $('span.payment-and-quantity__add .product-add').trigger('click');
});

$(window).scroll(function(){ 
  if ($(window).scrollTop() >= 300) {
    $('.announcement-header').addClass('fixed-header');
    var height =  $('.announcement-header').height();
    $('body').css('padding-top',height+'px');
    $('body').addClass('visible-title');
  }
  else {
    $('.announcement-header').removeClass('fixed-header');
    $('body').removeClass('visible-title');
    $('body').css('padding-top','0px');
  }
});

// ===================== Loader =====================

$(window).on('load', function() {       
  $("div#loader-wrapper").addClass("loaded").fadeOut(1500);
});

//  cookie-popup
$(document).ready(function(){
  $('#popin_tc_privacy_button_3, .enregistrer-btn').click(function(){
    localStorage.setItem('cookies',false);
    $(this).parents('.cookies-popup').addClass('hidden');
  });
  $('#popin_tc_privacy_button_2').click(function(){
    localStorage.setItem('cookies',true);
    $(this).parents('.cookies-popup').find('.cookies-popup-container').removeClass('active');
    $(this).parents('.cookies-popup').find('.reset-cookies-popup').addClass('active');
  });

  setTimeout(function(){
    if(localStorage.getItem('cookies') == 'false'){

      $('.cookies-popup').addClass('hidden');
      $('body').addClass('cookies-popup-open');
    }else{
      $('.cookies-popup').removeClass('hidden');
      $('body').removeClass('cookies-popup-open');
    }
  },3200);

  $('.reset-btn-close').click(function(){
    $(this).parents('.cookies-popup-container').removeClass('active');
    $(this).parents('.cookies-popup').find('.tc-privacy-wrapper').addClass('active');
  });

  $('.btn-yes').click(function(){
    $(this).parents('.btn-toggle').addClass('btn-toggle-on').attr('aria-checked', true);
  });
  $('.btn-no').click(function(){
    $(this).parents('.btn-toggle').removeClass('btn-toggle-on').attr('aria-checked', false);
  });
});

// =======================Slider Home=============================
$('.slider_left_part').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1, 
  arrows: false, 
  dots: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows: true, 
      }
    }    
  ]
});

$('#featuredblog').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1, 
  arrows: false, 
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }    
  ]
});

$('.slider_left_part').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,  
  arrows: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 376,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
});

// Accordion Design js
if ($(".accordion-box").length) {
    $(".accordion-box").on("click", ".acc-btn", function () {
        var outerBox = $(this).parents(".accordion-box");
        var target = $(this).parents(".accordion");
        if ($(this).next(".acc-content").is(":visible")) {
            //return false;
            $(this).removeClass("active");
            $(this).next(".acc-content").slideUp(300);
            $(outerBox).children(".accordion").removeClass("active-block");
        } else {
            $(outerBox).find(".accordion .acc-btn").removeClass("active");
            $(this).addClass("active");
            $(outerBox).children(".accordion").removeClass("active-block");
            $(outerBox).find(".accordion").children(".acc-content").slideUp(300);
            target.addClass("active-block");
            $(this).next(".acc-content").slideDown(300);
        }
    });
}

// =============================== Footer top Section ==================
// $('.index-section .index-section-wrapper').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,  
//   arrows: false,
//   prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
//   nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: false,
//         dots: false,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 376,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: true
//       }
//     }
//   ]
// });

// FAQ

// $('.queans__main .question').click(function(){
//   $('.queans__main').not($(this).parent()).removeClass('active');
//   $(this).parent().toggleClass('active');
//   $('.answer').not($(this).siblings()).slideUp();
//   $(this).siblings().slideToggle();
// });


$(document).ready(function(){
if($(window).width() < 992){
      $('#slider_a').slick({
    slidesToShow: 3,
  autoplay: true,
     dots: false,
  speed: 3000,
 autoplaySpeed: 0,
    arrows:false,
     infinite: true,
        pauseOnHover: false,
        cssEase: 'linear',
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
            }
          }
          
  ]
    });
}
});

// $(document).resize(function(){
// if($(window).width() < 992){
//     $('#slider_a').slick({
//     slidesToShow: 3,
//   speed: 3000,
//   autoplay: true,
//      dots: false,
//     arrows:false,
//     autoplaySpeed: 0,
//      infinite: true,
//       pauseOnHover: false,
//       cssEase: 'linear',
//       responsive: [
//           {
//             breakpoint: 768,
//             settings: {
//               slidesToShow: 2
//             },
//           },
//           {
//             breakpoint: 575,
//             settings: {
//               slidesToShow: 1,
//             }
//           }
          
//   ]
//     });
// }
// });



//-----------------------colle-page-slider 
$('.coll-page-slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1, 
  arrows: true, 
  dots: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
          arrows: true, 
      }
    }, 
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
          arrows: true, 
      }
    }, 
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows: true, 
      }
    }    
  ]
});


$('.pop_video_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1, 
  arrows: true, 
  dots: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>'  

});

// ------------------cart page tab

$(function() {
  $('.cart-delivery-arthur-box .tabs-nav a').click(function() {


    $('.cart-delivery-arthur-box .tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    
    let currentTab = $(this).attr('href');
    $('.cart-delivery-arthur-box .tabs-content div').hide();
    $(currentTab).show();

    return false;
  });
  $(window).scroll(function(){
      if ($(this).scrollTop() > 100) {
          $('.product_sticky_btn').addClass('fixed');
      } else {
          $('.product_sticky_btn').removeClass('fixed');
      }
  });
  

});







// jQuery(".instant_saving_cart .cart-btn-drawer").click(function(e) {
//     e.preventDefault();
//     alert("addd");  
//     var val = jQuery(this).parents(".instant_saving_cart .product_related_cart").find('input[name="id"]').val();
//     console.log(val);
//     var qty = jQuery(this).parents(".instant_saving_cart .product_related_cart").find('input[name="quantity"]').val();
//     console.log(qty);
//     // var qty = 1;
//     jQuery.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {"id":val,"quantity":qty},
//         dataType: 'json',
//         success: function(data) { 
//           // var cartItemCount = data.item_count;
//           // console.log(cartItemCount);
//           //updateCartDrawer();
//           jQuery.getJSON('/cart.js', function(cart) {
//              // now have access to Shopify cart object
//             var cart_count = cart.item_count;
//              //alert('There are now ' + cart.item_count + ' items in the cart.');
//               $(".cart-summary__item-list-header__count").text('(' + cart_count + ')');
//           } );
//           console.log('Product added');
//         },
//         error: function() {
//           console.log('error');
//         }
//       });
//   });

// $(document).ready(function() {
//   $('.vid-main').click(function(){
//     $(this).find('.popup-overlay').addClass('show');
//   });

//   $('.popup-close').click(function(){
//     $(this).parents('.popup-overlay').removeClass('show');
//   });
// });

$(document).ready(function() {
  // Open the popup
  $('.pop_main_col').click(function(){
  $(this).parent('.vid-main').find('.popup-overlayy').addClass('pop_show');
  $('body').addClass('pop_open');
});

$('.popup-closee').click(function(){
 $('.popup-overlayy').removeClass('pop_show');
  $('body').removeClass('pop_open');
});
  
});






